import { toast } from "sonner";

const CHAVE = "dentalbook:estacao-de-etiquetas";

/**
 * O atalho "DentalBook Etiquetas" abre o app com `?estacao=etiquetas`, num perfil do Chrome só dele
 * e com impressão direta (sem diálogo). Fica marcado no armazenamento daquele perfil: a janela do dia
 * a dia, em outro perfil, nunca é marcada.
 */
export function lembrarEstacaoDeEtiquetas() {
  try {
    if (new URLSearchParams(window.location.search).get("estacao") === "etiquetas") localStorage.setItem(CHAVE, "1");
  } catch {
    // Sem armazenamento: a janela só não avisa antes de imprimir documento.
  }
}

export function ehEstacaoDeEtiquetas() {
  try {
    return localStorage.getItem(CHAVE) === "1";
  } catch {
    return false;
  }
}

/**
 * Recibo, orçamento e afins: na janela de etiquetas iriam direto pra impressora de etiquetas. Avisa e
 * só imprime se a pessoa insistir. Devolve `true` quando segurou a impressão.
 */
export function segurarDocumentoNaEstacao(imprimirMesmoAssim: () => void) {
  if (!ehEstacaoDeEtiquetas()) return false;
  toast.warning("Esta janela imprime direto na impressora de etiquetas.", {
    description: "Para recibos e orçamentos, use o navegador do dia a dia, que pergunta a impressora.",
    action: { label: "Imprimir mesmo assim", onClick: imprimirMesmoAssim },
    duration: 10000,
  });
  return true;
}
